import { HeaderConfig } from '@/types/header-footer-config'

export const headerWidthClassNames: Record<NonNullable<HeaderConfig['leftSectionWidth']>, string> = {
  auto: '',
  sm: 'max-w-40',
  md: 'max-w-56',
  lg: 'max-w-72',
  full: 'w-full',
}

export const headerSpacingClassNames: Record<NonNullable<HeaderConfig['spacing']>, string> = {
  compact: 'gap-4 md:gap-6',
  normal: 'gap-6 md:gap-10',
  relaxed: 'gap-8 md:gap-12',
}

export const headerContainerWidthClassNames: Record<NonNullable<HeaderConfig['containerWidth']>, string> = {
  auto: '',
  sm: 'max-w-4xl mx-auto',
  md: 'max-w-5xl mx-auto',
  lg: 'max-w-6xl mx-auto',
  full: 'w-full',
}
